
export default function PassionSection() {
  const passions = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'Relation client privilégiée',
      description: 'Un partenariat durable basé sur la confiance mutuelle',
      image: 'https://public.readdy.ai/ai/img_res/cb5ecc0f76a3121d4e6e996f149b7121.jpg'
    },
    {
      icon: 'ri-team-fill',
      title: 'Collaboration performante et sereine',
      description: 'Travail d\'équipe efficace pour des résultats optimaux',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20security%20system%20integration%20showing%20multiple%20security%20devices%20working%20together%2C%20access%20control%20panel%20connected%20to%20alarm%20system%20and%20cameras%2C%20synchronized%20security%20equipment%20operation%2C%20professional%20installation%20with%20all%20systems%20communicating%2C%20integrated%20security%20solution%20in%20modern%20building&width=400&height=300&seq=collaboration-systeme&orientation=landscape'
    },
    {
      icon: 'ri-target-line',
      title: 'Répondre au mieux à vos besoins',
      description: 'Solutions sur mesure adaptées à chaque situation',
      image: 'https://readdy.ai/api/search-image?query=Custom%20security%20system%20design%20with%20multiple%20protection%20layers%2C%20tailored%20security%20solution%20showing%20access%20control%20keypad%2C%20security%20cameras%2C%20and%20alarm%20sensors%20perfectly%20positioned%20for%20maximum%20coverage%2C%20professional%20security%20equipment%20strategically%20placed%20in%20building%20entrance&width=400&height=300&seq=besoins-sur-mesure&orientation=landscape'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Perfection des détails du projet',
      description: 'Attention minutieuse à chaque aspect de l\'installation',
      image: 'https://readdy.ai/api/search-image?query=High%20precision%20security%20equipment%20installation%20showing%20perfectly%20aligned%20access%20control%20reader%20and%20keypad%20with%20clean%20cable%20management%2C%20professional%20mounting%20of%20fire%20detector%20on%20ceiling%20with%20precise%20positioning%2C%20detailed%20view%20of%20security%20system%20components%20perfectly%20installed&width=400&height=300&seq=details-installation&orientation=landscape'
    },
    {
      icon: 'ri-emotion-happy-line',
      title: 'Vous donner le sourire à chaque étape',
      description: 'Satisfaction client garantie tout au long du processus',
      image: 'https://readdy.ai/api/search-image?query=Security%20system%20successfully%20preventing%20intrusion%20attempt%2C%20surveillance%20camera%20detecting%20suspicious%20activity%20with%20motion%20sensor%20alerts%20activated%2C%20burglar%20being%20detected%20by%20professional%20security%20system%2C%20red%20alert%20indicators%20on%20security%20panel%20showing%20system%20working%20effectively&width=400&height=300&seq=securite-en-action&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Notre métier, nos passions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La sécurité en action pour votre protection
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {passions.map((passion, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={passion.image}
                  alt={passion.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20"></div>
                <div className={`absolute top-4 left-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg`}>
                  <i className={`${passion.icon} text-xl text-orange-500`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {passion.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {passion.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
